// extracted by mini-css-extract-plugin
export default {"container":"ML-z","topReviewHeading":"NL-z","criticalReview":"OL-z","favorableReview":"PL-z","vsSeparator":"QL-z"};